

const getTagsFromEntityMap = (entityMap) => {
  const tags = new Set()
  Object.values(entityMap).forEach((entity) => {
    if (entity.type === 'TAG') {
      tags.add(entity.data.value)
    }
  })
  return Array.from(tags)
}

export default getTagsFromEntityMap
